/**
 * Доступ в админку (§51).
 *
 * Проверка на клиенте — только чтобы не показывать пустые экраны; настоящая
 * защита на сервере (`requireAdmin`). Клиентский гвард без серверного —
 * это не защита, а внешний вид защиты.
 */
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';

export function AdminGuard() {
  const status = useAuthStore((state) => state.status);
  const user = useAuthStore((state) => state.user);

  if (status === 'loading') return <div className="min-h-full bg-page" />;
  if (status !== 'authenticated') return <Navigate to="/login" replace />;
  // Не «Доступ запрещён», а просто главная: пользователю незачем знать,
  // что здесь вообще что-то есть.
  if (user?.role !== 'admin') return <Navigate to="/" replace />;

  return <Outlet />;
}
